const formatFlightSeats = (flights, travelers) => {
  const selectedSeats = [];
  flights.forEach((f) => {
    travelers.forEach((t) => {
      if (t.travelerPreferences && t.travelerPreferences.flightSeatNumbers
        && t.travelerPreferences.flightSeatNumbers[f.flightNumber]
        && t.travelerPreferences.flightSeatNumbers[f.flightNumber].seatNumber) {
        selectedSeats.push(t.travelerPreferences.flightSeatNumbers[f.flightNumber].seatNumber);
      }
    });
  });
  if (selectedSeats.length) {
    return selectedSeats.join(', ');
  }
  return null;
};

export default formatFlightSeats;
